    <ng-container >
        <div class="text-right" *ngIf="billerOpratorList.length == 0">
            <img src="assets/img/bbps/bharat-connect.png" alt="barat-connect">
        </div>
    </ng-container>

    
    <div class="card d-block "  [ngStyle]="billerOpratorList.length > 0 ? {'margin-top': '32px'} : {}">
        <div class="bbps-card">
            <ng-container *ngFor="let item of billerList; let i = index">

                <ng-container *ngIf="show || (!show && i < 6)  ">
                    <div class="bbps-card-item " [class.activeEffect]="selectedIndex == i "
                        (click)="selected(item , i)">
                        <div class="icon">
                            <!-- <img src="https://uat.sprintnxt.in/merchant/console/ccavenuelogo/{{item.category_code}}.svg" alt="electricity"> -->

                            <img src="assets/icons/{{item.category_code_name}}.png" alt="{{item.category_code_name}}">

                            <!-- <img src="assets/icons/WATER.svg" alt="electricity"> -->
                        </div>
                        <h5 class="card-title"> {{item?.category_name}}</h5>
                    </div>
                </ng-container>
            </ng-container>
        </div>
        <div *ngIf="!show" class="mt-4 text-center" (click)="show = !show">
            <a href="javascript:void(0)">Show {{ show ?' Less':' More'}} <i
                    class="far fa-chevron-{{show?'up':'down'}}"></i></a>
        </div>
        <!-- <div *ngIf="billerList?.length > 6" class="mt-4 text-center" (click)="ShowAllLess()">
            <a href="javascript:void(0)">Show Less <i class="far fa-chevron-up"></i></a>
        </div> -->
    </div>

    <!-- <div class="mt-4 text-center">
        <a href="#">Show More <i class="fa-solid fa-angle-down"></i></a>
    </div> -->
    @if (billerOpratorList.length > 0) {

    <div class="text-right">
        <img src="assets/img/bbps/bharat-connect.png" alt="barat-connect">
    </div>
    <div class="card d-block mt-1 p-4 ">
        <div *ngIf="selectedItem" class="select-item">
            <img src="assets/icons/{{selectedItem.category_code_name}}.svg" alt="electricity">
            <span>{{selectedItem.category_name}}</span>
        </div>
        <div class="form-group mb-3" #showInput>
            <!-- <select (input)="option($event)" class="form-select form-select-lg" aria-label="Default select example"> -->
            <select  [formControl]="slectedValue"
                class="form-select form-select-lg  border-primary text-dark p-2 rounded form-control"
                aria-label="Default select example">
                <option selected value="" disabled>Search Operators  </option>
                <option [ngValue]="item" *ngFor="let item of billerOpratorList">{{item.biller_name}}</option>
            </select>




            <!-- <select class="form-control" 
            class="form-control" 
              >
      <option *ngFor="let option of billerOpratorList" [value]="option.biller_name">
        {{ option.biller_name }}
      </option>
    </select> -->
        </div>

        <!-- <div class="form-group" #showInput> -->
        <!-- <label for="input-datalist">select :</label> -->
        <!-- <input type="text" class="form-control" placeholder="selecte..." list="list-timezone" id="input-datalist" (input)="option($event)" >
            <datalist id="list-timezone" >
                <option   [value]="item.biller_name" *ngFor="let item of billerOpratorList" >{{item.biller_name}}</option>
            </datalist> -->
        <!-- </div> -->


    </div>
    }
